import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardTitle, CardText,
  Container, Row, Col, Badge, Input,
} from "reactstrap";
import { businessesRepo } from "data/repositories/businessesRepo";
import SearchBox from "components/SearchBox";
import EmptyState from "components/EmptyState";

const CATEGORY_LABELS = {
  hotel: "Otel",
  resort: "Resort",
  pension: "Pansiyon",
  restaurant: "Restoran",
  agency: "Tur Ajansı",
  souvenir: "Hediyelik",
  transport: "Ulaşım",
  guide: "Rehber",
};

export default function BusinessesList() {
  const [businesses, setBusinesses] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");

  useEffect(() => {
    setBusinesses(businessesRepo.list());
  }, []);

  const filtered = businesses
    .filter((b) => (category ? b.category === category : true))
    .filter((b) => b.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">İşletmeler</h2>
          <p className="text-white opacity-8">Karadeniz'deki oteller, restoranlar ve daha fazlası</p>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row className="mb-3 align-items-end">
          <Col md={6}>
            <SearchBox value={search} onChange={setSearch} placeholder="İşletme ara..." />
          </Col>
          <Col md={3}>
            <Input type="select" value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="">Tüm kategoriler</option>
              {Object.entries(CATEGORY_LABELS).map(([k, v]) => (
                <option key={k} value={k}>{v}</option>
              ))}
            </Input>
          </Col>
        </Row>

        {filtered.length === 0 ? (
          <EmptyState title="İşletme bulunamadı" />
        ) : (
          <Row>
            {filtered.map((b) => (
              <Col key={b.id} lg={4} md={6} xs={12} className="mb-4">
                <Card className="shadow h-100" tag={Link} to={`/admin/businesses/${b.id}`} style={{ textDecoration: "none" }}>
                  <CardBody>
                    <CardTitle tag="h4" className="mb-1">{b.name}</CardTitle>
                    <CardText className="text-muted small mb-2">{b.description}</CardText>
                    <Badge color="info" className="mr-2">{CATEGORY_LABELS[b.category] || b.category}</Badge>
                    <Badge color="light" className="text-dark">{b.location?.provinceId || "-"}</Badge>
                    {b.priceFromText && <small className="ml-2 text-muted">{b.priceFromText}</small>}
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
}
